<div class="text-area-component">
  <label>{{label || ''}}</label>
  <div #dvContenido></div>
</div>
